import { chartTypes } from '@/components/charts/common/chartTypes';
import { SwotRenderer } from '@/components/charts/Swot/SwotRenderer';
import { SwotScaler } from '@/components/charts/Swot/SwotScaler';
import { SwotTooltip } from '@/components/charts/Swot/SwotTooltip';

export class SwotModule {
    static get type () {
        return chartTypes.SWOT;
    }

    constructor ({ canvas, chartRenderer, chartDataHelper, chartInteractions }) {
        this.scaler = new SwotScaler({
            canvas, chartDataHelper
        });

        this.tooltip = new SwotTooltip({
            type: SwotModule.type, chartInteractions, chartDataHelper
        });

        this.renderer = new SwotRenderer({
            canvas,
            chartRenderer,
            chartDataHelper,
            chartInteractions,
            scaler: this.scaler
        });

        chartInteractions.onModuleToggleZoom(
            chartDataHelper.type, this._toggleZoom.bind(this));
    }

    render (mode) {
        this.scaler.buildScales(this.renderer.context);
        this.renderer.render(mode);
    }

    _toggleZoom (zoomIn) {
        this.renderer.context.zoom = zoomIn;
        this.render('refresh');
    }
}
